import { render, staticRenderFns } from "./AlignJustify.vue?vue&type=template&id=3ceabf7a&"
import script from "./AlignJustify.vue?vue&type=script&lang=js&"
export * from "./AlignJustify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports